<ng-template #modalViewTask let-modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" *ngIf="task && _utilsService.isDesktop">
    <div class="row border-bottom">
      <div class="col-md-6 col-12 pt-1" [ngClass]="{'pb-0': editMode, 'pb-1': !editMode}">
        <div class="d-flex align-items-center" [ngClass]="{'justify-content-between': !editMode, 'justify-content-end': editMode}">
          <div class="d-flex align-items-center">
            <div class="border-right pr-2 mr-2" *ngIf="!editMode">
              <div *ngIf="(task.status_changer.hash !== myHash && task.status > 0) || task.view_because === 'have_capability'">
                <button type="button" class="btn" [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }" rippleEffect>
                  {{ "STATUS." + (task.status === 0 ? "TODO" : task.status === 1 ? "IN_PROGRESS" : "COMPLETED") | translate }}
                </button>
              </div>
              <div ngbDropdown class="btn-group" *ngIf="!statusChanging && (task.status_changer.hash === myHash || task.status === 0) && task.view_because !== 'have_capability'">
                <button type="button" class="btn" [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }" rippleEffect>
                  {{ "STATUS." + (task.status === 0 ? "TODO" : task.status === 1 ? "IN_PROGRESS" : "COMPLETED") | translate }}
                </button>
                <!--Se in lavorazione lo stato del task può modificarlo solo chi ha impostato lo stato in lavorazione -->
                <button
                  ngbDropdownToggle
                  type="button"
                  rippleEffect
                  class="btn dropdown-toggle-split"
                  *ngIf="(task.status === 1 && task.status_changer.hash === myHash) || task.status !== 1"
                  [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }"
                ></button>
                <div ngbDropdownMenu>
                  <a ngbDropdownItem class="{{ task.status === 0 ? 'active bg-secondary' : null }}" href="javascript:void(0)" (click)="setToDoStatus()" [disabled]="task.status === 0">{{ "STATUS.TODO" | translate }}</a>
                  <a ngbDropdownItem class="{{ task.status === 1 ? 'active bg-warning' : null }}" href="javascript:void(0)" (click)="setTaken()" [disabled]="task.status === 1">{{ "STATUS.IN_PROGRESS" | translate }}</a>
                  <a ngbDropdownItem class="{{ task.status === 2 ? 'active bg-success' : null }}" href="javascript:void(0)" (click)="setCompleted()" [disabled]="task.status === 2">{{ "STATUS.COMPLETED" | translate }}</a>
                </div>
              </div>
              <div *ngIf="statusChanging">
                <span [data-feather]="'loader'" [class]="'spinner'" size="18"></span>
              </div>
            </div>
            <div class="badge-wrapper" *ngIf="!editMode">
              <span [ngbTooltip]="'LOW_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 0">
                <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
              </span>
              <span [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 1">
                <i [data-feather]="'flag'" size="20" class="text-warning"></i>
              </span>
              <span [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 2">
                <i [data-feather]="'flag'" size="20" class="text-danger"></i>
              </span>
            </div>
            <div class="badge-wrapper mr-4" *ngIf="editMode">
              <span class="cursor-pointer" [ngClass]="task.priority === 0 ? '' : 'opacity-35'" [ngbTooltip]="'LOW_PRIORITY' | translate" placement="bottom" (click)="task.priority = 0">
                <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
              </span>
              <span class="mx-1 cursor-pointer" [ngClass]="task.priority === 1 ? '' : 'opacity-35'" [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="bottom" (click)="task.priority = 1">
                <i [data-feather]="'flag'" size="20" class="text-warning"></i>
              </span>
              <span class="cursor-pointer" [ngClass]="task.priority === 2 ? '' : 'opacity-35'" [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="bottom" (click)="task.priority = 2">
                <i [data-feather]="'flag'" size="20" class="text-danger"></i>
              </span>
            </div>
            <div class="border-left pl-2 ml-2" *ngIf="!editMode">
              <div class="font-small-2 text-uppercase">{{ "EXPIRE_DATE" | translate }}:</div>
              {{ _utilsService.formatDate(task.end_date) }}
            </div>
          </div>
          <div class="text-right" *ngIf="canEdit">
            <a  *ngIf="!editMode" (click)="editMode = true" class="text-warning mr-2" [ngbTooltip]="'EDIT' | translate" placement="top">
              <i [data-feather]="'edit-2'" size="20"></i>
            </a>
            <button type="button" *ngIf="editMode && !isUploadingFile" (click)="edit()" class="bg-transparent border-0 text-success mr-2" [ngbTooltip]="'SAVE' | translate" placement="top">
              <i [data-feather]="'check'" size="20"></i>
            </button>
            <a (click)="delete()" class="text-danger" [ngbTooltip]="'DELETE' | translate" placement="top">
              <i [data-feather]="'trash'" size="20"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 border-left pt-1" [ngClass]="{'pb-0': editMode, 'pb-1': !editMode}">
        <div class="d-flex justify-content-between mb-075">
          <div>
            <div class="font-small-2 text-uppercase">{{ "CREATED_AT_FEMALE" | translate }}:</div>
            {{ _utilsService.formatDate(task.insert_date) }}
          </div>
          <div class="text-right">
            <div class="font-small-3" *ngIf="task.group">
              {{ "TASK_ASSIGNED_TO_GROUP" | translate }} <span class="font-small-4">{{ task.group_name }}</span>
            </div>
            <div class="font-small-3" *ngIf="task.role">
              {{ "TASK_ASSIGNED_TO_ROLE" | translate }} <span class="font-small-4 font-weight-bold">{{ task.role_name }}</span>
              {{ task.users.length > 0 ? ("AND_TO"| translate) + ' ' + task.users.length + ' ' + ("TITLES.USERS_TYPES.employee" | translate | lowercase) : '' }}
            </div>
            <div class="d-flex align-items-center justify-content-end" *ngIf="task.users.length > 0">
              <div class="font-small-3 flex-basis-100 text-right" *ngIf="!task.role && !task.group">{{ "ASSIGNED" | translate }}:</div>
              <div class="ml-1 avatar-group" *ngIf="task.users.length > 0">
                <div *ngFor="let user of task.users; let i = index" class="avatar pull-up">
                  <a [routerLink]="['/dashboard/user/profile', user.hash]" target="_blank" [ngbTooltip]="user.complete_name">
                    <img #image (error)="image.hidden = true" [src]="user.avatar" alt="Avatar" height="30" width="30" class="cover" />
                    <div *ngIf="image.hidden" class="avatar-content text-uppercase">{{ user.complete_name | initials }}</div>
                  </a>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <div id="task_title1" class="mt-1 mb-2">
          <h3 *ngIf="!editMode">{{ task.title }}</h3>
          <input type="text" *ngIf="canEdit && editMode" class="form-control" [(ngModel)]="task.title" />
        </div>
        <div id="task_description">
          <strong *ngIf="task.description.length > 0 && !editMode">{{ "DESCRIPTION" | translate }}</strong>
          <div *ngIf="!editMode" [innerHTML]="task.description | safe: 'html'"></div>
          <angular-editor *ngIf="canEdit && editMode" id="description" [config]="_utilsService.defaultEditorConfig" [(ngModel)]="task.description"></angular-editor>
        </div>
        <div class="border-top pt-1">
          <strong>{{ "ATTACHMENTS" | translate }}</strong>
          <div class="mt-075" *ngIf="!task.attachments || task.attachments.length < 1">{{ "NO_ATTACHMENTS_FOR_THIS_TASK" | translate }}</div>
          <div class="mt-075 d-flex flex-wrap" *ngIf="task.attachments && task.attachments.length > 0">
            <span *ngFor="let attach of task.attachments; let i = index" class="d-flex mr-05 mb-05 badge badge-light-secondary">
              <div class="cursor-pointer" (click)="showAttach(attach.url)">{{ attach.filename }}</div>
              <div class="ml-05 cursor-pointer" *ngIf="canEdit" (click)="removeFileFromList(attach.id)">
                <i [data-feather]="'x'" class="text-danger" size="18"></i>
              </div>
            </span>
          </div>
        </div>
        <div id="file-uploader" class="custom-file my-2" *ngIf="canEdit && editMode">
          <input class="custom-file-input" type="file" lang="it" id="file"
                 [multiple]="true" (change)="addFileToList($any($event).target.files)"
                 accept="application/msword, application/vnd.ms-excel, text/plain, application/pdf, image/*" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>
      <div class="form-group col-md-6 col-12 border-left pt-1" *ngIf="editMode">
        <div class="mb-1">
          <label for="users3">{{ "SELECT_COLLEAGUES" | translate }} <sup class="text-danger">*</sup></label>
          <ng-select id="users3" bindLabel="complete_name" bindValue="hash" [(ngModel)]="assignedUser"
                     [multiple]="true" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false"
                     [virtualScroll]="true" [items]="employees_list" [maxSelectedItems]="employee_limit"></ng-select>
          <div class="cursor-pointer text-primary" (click)="assignToMySelf()" *ngIf="assignedUser?.length < employee_limit && (!assignedUser || (assignedUser && !assignedUser.includes(myHash)))">
            {{ "ASSIGN_TO_MY_SELF" | translate }}
          </div>
        </div>
        <!--        <div has_capability="assign_task_to_group">-->
        <!--          <label for="group2">{{ "SELECT_GROUP" | translate }} <sup class="text-danger">*</sup></label>-->
        <!--          <ng-select-->
        <!--            id="group2"-->
        <!--            bindLabel="name"-->
        <!--            bindValue="id"-->
        <!--            [(ngModel)]="assignedGroup"-->
        <!--            [searchable]="true"-->
        <!--            [closeOnSelect]="true"-->
        <!--            [clearable]="false"-->
        <!--            [openOnEnter]="false"-->
        <!--            [multiple]="false"-->
        <!--            [virtualScroll]="true"-->
        <!--            [items]="_groupService.list"-->
        <!--          ></ng-select>-->
        <!--        </div>-->
        <div has_capability="assign_task_to_role">
          <label for="role2">{{ "SELECT_ROLE" | translate }} <sup class="text-danger">*</sup></label>
          <ng-select id="role2" bindLabel="name" bindValue="id"
                     [(ngModel)]="assignedRole" [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                     [openOnEnter]="false" [multiple]="false" [virtualScroll]="true" [items]="_roleService.list"></ng-select>
        </div>
        <div class="my-1">
          <label for="endDate2">{{ "EXPIRE_DATE" | translate }} <sup class="text-danger">*</sup></label>
          <ng2-flatpickr id="endDate2" [config]="endDate_add" [(ngModel)]="end_date" placeholder="gg/mm/aaaa"></ng2-flatpickr>
        </div>
      </div>

      <div class="col-md-6 col-12 border-left" *ngIf="!editMode">
        <div id="comments_list" [class]="task.view_because !== 'have_capability' ? '' : 'h-100'">
          <div *ngFor="let event of task.events; let i = index" class="comment-item border-bottom">
            <!-- commento -->
            <div *ngIf="event.id">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <!--Avatar-->
                  <div class="avatar mr-1" *ngIf="event.avatar">
                    <img [src]="event.avatar" [alt]="event.user_complete_name" height="30" width="30" class="cover" />
                  </div>
                  <div>
                    <!--Nome-->
                    <a target="_blank" [routerLink]="['/dashboard/user/profile', event.user_hash]">{{ event.user_complete_name }}</a>
                    <!--Data(insert_date per la creazione e date per i log e i commenti)-->
                    <div class="text-muted font-small-2">{{ _utilsService.formatDate(event.date) }}</div>
                  </div>
                </div>
                <div *ngIf="event.user_hash === myHash" class="text-right">
                  <div (click)="deleteComment(event.id)" class="text-danger cursor-pointer" [ngbTooltip]="'DELETE' | translate">
                    <i [data-feather]="'trash'" size="20"></i>
                  </div>
                </div>
              </div>
              <div [innerHTML]="event.comment" class="mt-075"></div>
            </div>
            <!-- cambi di stato -->
            <div *ngIf="!event.id">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <!--Avatar-->
                  <div class="avatar mr-1" *ngIf="event.avatar">
                    <img [src]="event.avatar" [alt]="event.user_complete_name" height="30" width="30" class="cover" />
                  </div>
                  <!--Nome-->
                  <a target="_blank" [routerLink]="['/dashboard/user/profile', event.user_hash]">{{ event.complete_name }}</a>
                  <span class="ml-025">{{ "HAS_CHANGE_STATUS" | translate }}</span>
                  <!-- nome dello stato -->
                  <span class="ml-025 badge" [ngClass]="{ 'badge-light-secondary': event.status === 0, 'badge-light-warning': event.status === 1, 'badge-light-success': event.status === 2 }">
                    {{ (event.status === 0 ? "STATUS.TODO" : event.status === 1 ? "PROGRESS" : "COMPLETED") | translate }}
                  </span>
                </div>
                <div class="text-muted font-small-2">{{ _utilsService.formatDate(event.date) }}</div>
              </div>
            </div>
          </div>
          <div class="comment-item border-bottom">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <!--Avatar-->
                <div class="avatar mr-1" *ngIf="task.creator.avatar">
                  <img [src]="task.creator.avatar" [alt]="task.creator.complete_name" height="30" width="30" class="cover" />
                </div>
                <!--Nome-->
                <ng-container *ngIf="task.creator.hash !== myHash">
                  <a target="_blank" *ngIf="task.creator.hash !== null " [routerLink]="['/dashboard/user/profile', task.creator.hash]">{{ task.creator.complete_name }}</a>
                  <strong *ngIf="task.creator.hash === null ">{{ "THE_SYSTEM" | translate }}</strong>
                  <span class="ml-025">{{ "HAS_CREATE_TASK" | translate }}</span>
                </ng-container>
                <ng-container *ngIf="task.creator.hash === myHash">
                  <span class="ml-025">{{ "YOU_HAV_CREATED_THIS_TASK" | translate }}</span>
                </ng-container>
              </div>
              <span class="text-muted font-small-2">{{ _utilsService.formatDate(task.insert_date) }}</span>
            </div>
          </div>
        </div>
        <div id="add_comment2" *ngIf="task.view_because !== 'have_capability'">
          <textarea class="form-control" [(ngModel)]="commentText" [placeholder]="'TYPE_A_COMMENT' | translate"></textarea>
          <button class="btn btn-primary mt-1" type="submit" (click)="sendComment()">{{ "SEND_COMMENT" | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body p-0" tabindex="0" *ngIf="task && _utilsService.isMobile">
    <!--sezione dati status task-->
    <section class="w-100 px-2 py-1 border-bottom">
      <div class="d-flex align-items-center justify-content-between">
        <!--scritta dello stato-->
        <div *ngIf="(task.status_changer.hash !== myHash && task.status > 0) || task.view_because === 'have_capability'">
          <button type="button" class="btn" [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }" rippleEffect>
            {{ "STATUS." + (task.status === 0 ? "TODO" : task.status === 1 ? "IN_PROGRESS" : "COMPLETED") | translate }}
          </button>
        </div>
        <!--bottoni-->
        <div ngbDropdown class="btn-group" *ngIf="!statusChanging && (task.status_changer.hash === myHash || task.status === 0) && task.view_because !== 'have_capability'">
          <button type="button" class="btn" [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }" rippleEffect>
            {{ "STATUS." + (task.status === 0 ? "TODO" : task.status === 1 ? "IN_PROGRESS" : "COMPLETED") | translate }}
          </button>
          <!--Se in lavorazione lo stato del task può modificarlo solo chi ha impostato lo stato in lavorazione -->
          <button
            ngbDropdownToggle
            type="button"
            rippleEffect
            class="btn dropdown-toggle-split"
            *ngIf="(task.status === 1 && task.status_changer.hash === myHash) || task.status !== 1"
            [ngClass]="{ 'btn-outline-secondary': task.status === 0, 'btn-outline-warning': task.status === 1, 'btn-outline-success': task.status === 2 }"
          ></button>
          <div ngbDropdownMenu>
            <a ngbDropdownItem class="{{ task.status === 0 ? 'active bg-secondary' : null }}" href="javascript:void(0)" (click)="setToDoStatus()">{{ "STATUS.TODO" | translate }}</a>
            <a ngbDropdownItem class="{{ task.status === 1 ? 'active bg-warning' : null }}" href="javascript:void(0)" (click)="setTaken()">{{ "STATUS.IN_PROGRESS" | translate }}</a>
            <a ngbDropdownItem class="{{ task.status === 2 ? 'active bg-success' : null }}" href="javascript:void(0)" (click)="setCompleted()">{{ "STATUS.COMPLETED" | translate }}</a>
          </div>
        </div>
        <!--spinner-->
        <div *ngIf="statusChanging">
          <span [data-feather]="'loader'" [class]="'spinner'" size="18"></span>
        </div>

        <!--bandierina priorità-->
        <div class="badge-wrapper" *ngIf="!editMode">
          <span [ngbTooltip]="'LOW_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 0">
            <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
          </span>
          <span [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 1">
            <i [data-feather]="'flag'" size="20" class="text-warning"></i>
          </span>
          <span [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="bottom-right" *ngIf="task.priority === 2">
            <i [data-feather]="'flag'" size="20" class="text-danger"></i>
          </span>
        </div>

        <!--bandierina priorità-->
        <div class="badge-wrapper" *ngIf="editMode">
          <span class="cursor-pointer" [ngClass]="task.priority === 0 ? '' : 'opacity-35'" [ngbTooltip]="'LOW_PRIORITY' | translate" placement="bottom" (click)="task.priority = 0">
            <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
          </span>
          <span class="mx-1 cursor-pointer" [ngClass]="task.priority === 1 ? '' : 'opacity-35'" [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="bottom" (click)="task.priority = 1">
            <i [data-feather]="'flag'" size="20" class="text-warning"></i>
          </span>
          <span class="cursor-pointer" [ngClass]="task.priority === 2 ? '' : 'opacity-35'" [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="bottom" (click)="task.priority = 2">
            <i [data-feather]="'flag'" size="20" class="text-danger"></i>
          </span>
        </div>
      </div>
      <!--data scadenza e creazione-->
      <div class="d-flex justify-content-between mt-1">
        <div *ngIf="!editMode">
          <div class="font-small-2 text-uppercase">{{ "EXPIRE_DATE" | translate }}:</div>
          {{ _utilsService.formatDate(task.end_date) }}
        </div>
        <div>
          <div class="font-small-2 text-uppercase">{{ "CREATED_AT_FEMALE" | translate }}:</div>
          {{ _utilsService.formatDate(task.insert_date) }}
        </div>
      </div>
      <!--assegnato + foto-->
      <div class="mt-1">
        <div class="font-small-3" *ngIf="task.group">
          {{ "TASK_ASSIGNED_TO_GROUP" | translate }} <span class="font-small-4">{{ task.group_name }}</span>
        </div>
        <div class="font-small-3" *ngIf="task.role">
          {{ "TASK_ASSIGNED_TO_ROLE" | translate }} <span class="font-small-4 font-weight-bold">{{ task.role_name }}</span>
        </div>
        <div *ngIf="task.users.length > 0">
          <div class="font-small-3" *ngIf="!task.role && !task.group">{{ "ASSIGNED" | translate }}:</div>
          <div class="avatar-group" *ngIf="task.users.length > 0">
            <div placement="bottom mr-05" *ngFor="let user of task.users; let i = index" [ngbTooltip]="user.complete_name" class="avatar pull-up">
              <a [routerLink]="['/dashboard/user/profile', user.hash]" target="_blank">
                <img #image (error)="image.hidden = true" [src]="user.avatar" alt="Avatar" height="30" width="30" class="cover" />
                <div *ngIf="image.hidden" class="avatar-content text-uppercase">{{ user.complete_name | initials }}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--titolo + descrizione-->
    <section class="w-100 px-2 py-1 border-bottom">
      <div id="task_title" class="mb-1 d-flex justify-content-between align-items-center">
        <h3 *ngIf="!editMode" class="mb-0">{{ task.title }}</h3>
        <input type="text" *ngIf="canEdit && editMode" class="form-control" [(ngModel)]="task.title" />
        <div class="text-right d-flex" *ngIf="canEdit">
          <a *ngIf="!editMode" (click)="editMode = true" class="text-warning mr-1" [ngbTooltip]="'EDIT' | translate" placement="top">
            <i [data-feather]="'edit-2'" size="18"></i>
          </a>
          <a *ngIf="editMode && !isUploadingFile" (click)="edit()" class="text-success mr-1" [ngbTooltip]="'SAVE' | translate" placement="top">
            <i [data-feather]="'check'" size="18"></i>
          </a>
          <a (click)="delete()" class="text-danger" [ngbTooltip]="'DELETE' | translate" placement="top">
            <i [data-feather]="'trash'" size="18"></i>
          </a>
        </div>
      </div>
      <div>
        <strong *ngIf="task.description.length > 0 && !editMode" class="mb-05">{{ "DESCRIPTION" | translate }}</strong>
        <div *ngIf="!editMode" [innerHTML]="task.description | safe: 'html'"></div>
        <angular-editor *ngIf="canEdit && editMode" [config]="_utilsService.defaultEditorConfig" [(ngModel)]="task.description"></angular-editor>
      </div>
    </section>
    <!--allegati-->
    <section class="w-100 px-2 py-1 border-bottom">
      <div>
        <strong>{{ "ATTACHMENTS" | translate }}</strong>
        <div class="mt-075" *ngIf="!task.attachments || task.attachments.length < 1">{{ "NO_ATTACHMENTS_FOR_THIS_TASK" | translate }}</div>
        <div class="mt-075 d-flex flex-wrap" *ngIf="task.attachments && task.attachments.length > 0">
          <span *ngFor="let attach of task.attachments; let i = index" class="d-flex mr-05 mb-05 badge badge-light-secondary">
            <div class="cursor-pointer" (click)="showAttach(attach.url)">{{ attach.filename }}</div>
            <div class="ml-05 cursor-pointer" *ngIf="canEdit" (click)="removeFileFromList(attach.id)">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
          </span>
        </div>
      </div>
      <div class="custom-file my-1" *ngIf="canEdit && editMode">
        <input
          class="custom-file-input"
          type="file"
          lang="it"
          [multiple]="true"
          (change)="addFileToList($any($event).target.files)"
          accept="application/msword, application/vnd.ms-excel, text/plain, application/pdf, image/*"
        />
        <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
      </div>
      <div class="form-group" *ngIf="editMode">
        <div class="my-1" *ngIf="list_assignTo.length === 1; else assignToManager">
          <label for="users1">{{ "SELECT_EMPLOYEES" | translate }} <sup class="text-danger">*</sup></label>
          <ng-select
            id="users1"
            bindLabel="complete_name"
            bindValue="hash"
            [(ngModel)]="assignedUser"
            [multiple]="true"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            [items]="employees_list"
            [maxSelectedItems]="employee_limit"
          ></ng-select>
        </div>
        <ng-template #assignToManager>
          <div class="my-1">
            <label for="assignTo">{{ "ASSIGN_TO" | translate }}</label>
            <ng-select
              id="assignTo"
              (ngModelChange)="changeAssignTo($event)"
              [multiple]="false"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [(ngModel)]="assignTo"
              [ngModelOptions]="{ standalone: true }"
            >
              <ng-option *ngFor="let item of list_assignTo" [value]="item.value">{{ item.label | translate }}</ng-option>
            </ng-select>
          </div>
          <div *ngIf="assignTo === 'employee'">
            <label for="users">{{ "SELECT_EMPLOYEES" | translate }} <sup class="text-danger">*</sup></label>
            <ng-select
              id="users"
              bindLabel="complete_name"
              bindValue="hash"
              [(ngModel)]="assignedUser"
              [multiple]="true"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [items]="employees_list"
              [maxSelectedItems]="employee_limit"
            ></ng-select>
          </div>
          <div *ngIf="assignTo === 'group'">
            <label for="users">{{ "SELECT_GROUP" | translate }} <sup class="text-danger">*</sup></label>
            <ng-select
              id="group"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="assignedGroup"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [multiple]="false"
              [virtualScroll]="true"
              [items]="_groupService.list"
            ></ng-select>
          </div>
          <div *ngIf="assignTo === 'role'">
            <label for="role">{{ "SELECT_ROLE" | translate }} <sup class="text-danger">*</sup></label>
            <ng-select
              id="role"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="assignedRole"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [multiple]="false"
              [virtualScroll]="true"
              [items]="_roleService.list"
            ></ng-select>
          </div>
        </ng-template>
        <div class="my-1">
          <label for="endDate">{{ "EXPIRE_DATE" | translate }} <sup class="text-danger">*</sup></label>
          <ng2-flatpickr id="endDate" [config]="endDate_add" [(ngModel)]="end_date" placeholder="gg/mm/aaaa"></ng2-flatpickr>
        </div>
      </div>
    </section>
    <!--commenti log ecc-->
    <section class="w-100 px-2 py-1 border-bottom">
      <div *ngIf="!editMode">
        <div id="comments_list_phone" [class]="task.view_because !== 'have_capability' ? '' : 'h-100'">
          <div *ngFor="let event of task.events; let i = index" class="comment-item border-bottom">
            <!-- commento -->
            <div *ngIf="event.id" class="row align-items-center">
              <!--nome-->
              <div class="col-8">
                <a target="_blank" [routerLink]="['/dashboard/user/profile', event.user_hash]">{{ event.user_complete_name }}</a>
              </div>
              <!--data-->
              <div class="col-4 text-right">
                <div class="text-muted font-small-2">{{ _utilsService.formatDate(event.date) }}</div>
              </div>
              <!--testo-->
              <div class="col-10 mt-05">
                <div [innerHTML]="event.comment"></div>
              </div>
              <!--cestino-->
              <div class="col-2 mt-05" *ngIf="event.user_hash === myHash">
                <div (click)="deleteComment(event.id)" class="text-danger text-right cursor-pointer" [ngbTooltip]="'DELETE' | translate">
                  <i [data-feather]="'trash'" size="18"></i>
                </div>
              </div>
            </div>

            <!--cambi di stato-->
            <div *ngIf="!event.id" class="row align-items-center">
              <div class="col-8 order-0">
                <a target="_blank" [routerLink]="['/dashboard/user/profile', event.user_hash]">{{ event.complete_name }}</a>
              </div>
              <div class="col-7 order-2 mt-05 pr-0">
                <span>{{ "HAS_CHANGE_STATUS" | translate }}</span>
              </div>
              <div class="col-5 text-right mt-05 order-3">
                <!-- nome dello stato -->
                <span class="m-0 badge" [ngClass]="{ 'badge-light-secondary': event.status === 0, 'badge-light-warning': event.status === 1, 'badge-light-success': event.status === 2 }">
                  {{ (event.status === 0 ? "STATUS.TODO" : event.status === 1 ? "PROGRESS" : "COMPLETED") | translate }}
                </span>
              </div>
              <div class="col-4 order-1">
                <div class="text-muted text-right font-small-2">{{ _utilsService.formatDate(event.date) }}</div>
              </div>
            </div>
          </div>
          <div class="comment-item">
            <div class="row">
              <div class="col-8">
                <a target="_blank" [routerLink]="['/dashboard/user/profile', task.creator.hash]">{{ task.creator.complete_name }}</a>
              </div>
              <div class="col-4 text-right">
                <span class="text-muted font-small-2">{{ _utilsService.formatDate(task.insert_date) }}</span>
              </div>
              <div class="col-12 mt-05">
                <span class="ml-025">{{ "HAS_CREATE_TASK" | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div id="add_comment" *ngIf="task.view_because !== 'have_capability'">
          <textarea class="form-control" [(ngModel)]="commentText" [placeholder]="'TYPE_A_COMMENT' | translate"></textarea>
          <button class="btn btn-primary mt-1" type="submit" (click)="sendComment()">{{ "SEND_COMMENT" | translate }}</button>
        </div>
      </div>
    </section>
  </div>
</ng-template>
